const MyPlugins = {
  install(Vue) {
    (Vue.prototype.$notification = function(message, variant) {
      Vue.$toast.open({
        message: message,
        type:
          variant === "danger" || variant === "error"
            ? "error"
            : variant === "success"
            ? "success"
            : "info",
      });
    }),
      (Vue.prototype.$getItemColor = function(item) {
        if (item.status === "Создан") {
          return "primary";
        } else if (item.status === "Изменен") {
          return "warning";
        } else if (item.status === "Не принято") {
          return "danger";
        } else if (item.status === "Cancelled") {
          return "danger";
        }
         else if (item.status === "Отменено") {
          return "danger";
        } else if (item.status === "Отклонен") {
          return "danger";
        }else if (item.status_name === "не выиграл") {
          return "danger";
        }
         else if (item.status === "Утвержден") {
          return "success";
        } else if (item.status === "Winner") {
          return "success";
        } else if (item.status === "Одобрен") {
          return "success";
        } else if (item.status === "Оценен") {
          return "secondary";
        } else if (item.status === "Отправлен") {
          return "info";
        } 
        else {
          return "primary";
        }
      });
    Vue.prototype.$getItemColorView = function(item) {
      if (item.statusid === 15) {
        return "primary";
      } else if (item.statusid === 16) {
        return "warning";
      } else if (item.statusid === "Не принято") {
        return "danger";
      } else if (item.status_name === "Cancelled") {
        return "danger";
      } else if (item.statusid === 23) {
        return "danger";
      } else if (item.statusid === 20) {
        return "danger";
      } else if (item.statusid === 22) {
        return "success";
      } else if (item.status_name === "Winner") {
        return "success";
      } else if (item.statusid === 19) {
        return "success";
      } else if (item.statusid === 21) {
        return "secondary";
      } else if (item.statusid === 17) {
        return "info";
      } else {
        return "primary";
      }
    };
    Vue.prototype.$getItemColorStatus = function(item) {
      if (item.statusname === "Создан") {
        return "primary";
      } else if (item.statusname === "Оплачено") {
        return "success";
      } else if (item.statusname === "Совершено") {
        return "primary";
      } else if (item.statusname === "Договор расторгнут (не оплачен) ") {
        return "danger";
      } else if (item.statusname === "Договор расторгнут (не поставлен) ") {
        return "warning";
      } else if (item.statusname === "Изменен") {
        return "warning";
      } else if (item.statusname === "Не принято") {
        return "danger";
      } else if (item.statusname === "Cancelled") {
        return "danger";
      } else if (item.statusname === "Отменено") {
        return "danger";
      } else if (item.statusname === "Отклонен") {
        return "danger";
      } else if (item.statusname === "Утвержден") {
        return "success";
      } else if (item.statusname === "Winner") {
        return "success";
      } else if (item.statusname === "Одобрен") {
        return "success";
      } else if (item.statusname === "Оценен") {
        return "secondary";
      } else if (item.statusname === "Отправлен") {
        return "info";
      } else {
        return "primary";
      }
    };
  },
};
export default MyPlugins;
